const contact = {
  eyebrow: 'Hablemos',
  title: 'Contáctenos',
  intro: '¿Tiene preguntas sobre nuestra canela de Ceilán? Con gusto le atendemos. Escríbanos y le responderemos en un día hábil.',

  quick: { label: 'Contacto rápido', whatsapp: 'WhatsApp', call: 'Llamar', email: 'Correo' },

  infoTitle: 'Estamos para ayudarle',
  infoText: 'Ya sea que le interesen pedidos al mayoreo, tenga preguntas sobre nuestros productos o quiera saber más sobre la canela de Ceilán, con gusto le ayudamos. Atendemos en español.',
  info: {
    address: 'Plantación en Sri Lanka',
    addressValue: '264/A, Regiland Estate, Batapola, Sri Lanka',
    singapore: 'Oficina en Singapur',
    singaporeValue: '6 Telok Blangah Crescent, #02-01, Singapur',
    email: 'Correo',
    phone: 'Teléfono',
    places: { sriLanka: 'Sri Lanka', singapore: 'Singapur' },
    whatsapp: 'WhatsApp',
    whatsappValue: 'Escríbanos ahora',
    hours: 'Horario',
    hoursValue: 'Lun - Vie: 9:00 - 18:00 (hora de Sri Lanka, GMT+5:30)',
  },
  social: 'Síganos',

  form: {
    title: 'Envíenos un mensaje',
    quoteTitle: 'Solicitar cotización',
    name: 'Nombre',
    namePlaceholder: 'Juan Pérez',
    email: 'Correo electrónico',
    emailPlaceholder: 'juan@ejemplo.com',
    message: 'Mensaje',
    messagePlaceholder: 'Cuéntenos qué necesita...',
    samplesTitle: 'Solicitar muestras',
    subject: 'Consulta desde el sitio web',
    send: 'Enviar mensaje',
    sending: 'Enviando...',
    errorGeneric: 'Algo salió mal. Inténtelo de nuevo.',
    errorNetwork: 'No se pudo enviar el mensaje. Inténtelo más tarde.',
    fallback: { before: 'También puede escribir a ', or: ' o ', whatsapp: 'enviarnos un WhatsApp', after: '.' },
  },

  quote: {
    subject: (products) => `Solicitud de cotización: ${products}`,
    quantityLine: (product) => `${product}, cantidad:`,
    rest: '\n\nEmpaque:\nPuerto de destino:\n',
  },

  samples: {
    subject: (products) => (products ? `Solicitud de muestras: ${products}` : 'Solicitud de muestras'),
    message: (products) => `${products ? `Muestras de: ${products}\n` : 'Grados que desea probar:\n'}Dirección de entrega:\nUso previsto:\n`,
  },

  success: {
    title: '¡Gracias!',
    text: 'Su mensaje se envió correctamente. Le responderemos en un día hábil.',
    again: 'Enviar otro mensaje',
  },
};

export default contact;
